import { ColumnsType } from 'antd/es/table';
import {
  StudentStatusEnum,
  studentType,
} from '../../../constants/types/student-type';
import { PaginationProps } from '../../../constants/types';
import StudentConroller from './StudentController';
import {
  ArrowsRightLeftIcon,
  DocumentMagnifyingGlassIcon,
  KeyIcon,
} from '@heroicons/react/24/outline';
import ActionButton from '../ActionButton';

const columns = (
  pageInfo: PaginationProps,
  classId: string,
  status: StudentStatusEnum,
  controller: StudentConroller,
  /** 처리 대기 중인 이관 신청이 있는 학생 id. 같은 학생을 중복 신청하지 않도록 표시를 바꾼다. */
  pendingTransferStudentIds: Set<number>,
): ColumnsType<studentType> => [
  {
    title: 'No.',
    key: 'index',
    render: (_, __, index) =>
      (pageInfo.page - 1) * pageInfo.pageSize + index + 1,
    align: 'center',
  },
  {
    title: '학생명',
    key: 'name',
    dataIndex: 'name',
    align: 'center',
  },
  {
    title: '아이디',
    key: 'uid',
    dataIndex: 'uid',
    align: 'center',
  },
  {
    title: '반',
    key: 'classGroup',
    render: (_, row) =>
      row.classInfos.find((classInfo) => classInfo.classId === classId)
        ?.classGroup?.name ?? <span className="text-gray5">반 없음</span>,
    align: 'center',
  },

  {
    title: '관리',
    key: 'manage',
    render: (_, row) => (
      <div className="flex flex-wrap items-center justify-center gap-1.5">
        <ActionButton
          label="비밀번호 초기화"
          icon={KeyIcon}
          color="purple"
          onClick={() => controller.resetHandler(row)}
        />
        {status === StudentStatusEnum.ACTIVE &&
          (() => {
            // 이관 신청 (처리 대기 중이면 눌러도 안내만 뜬다)
            const isPending = pendingTransferStudentIds.has(row.id);

            return (
              <ActionButton
                label={isPending ? '이관 대기중' : '이관 신청'}
                icon={ArrowsRightLeftIcon}
                color={isPending ? 'gray' : 'skyblue'}
                onClick={() => controller.transferHandler(row, isPending)}
                // 라벨 길이가 달라도 행마다 버튼 너비가 같도록 고정한다.
                className="w-[104px]"
              />
            );
          })()}
      </div>
    ),
    align: 'center',
  },
  {
    title: '상세',
    key: 'detail',
    render: (_, row) => (
      <ActionButton
        label="상세보기"
        icon={DocumentMagnifyingGlassIcon}
        color="orange"
        onClick={() => controller.detailHandler(row.id)}
      />
    ),
    align: 'center',
  },
];

export default columns;
